import React from 'react';
import i18next from "i18next"

const PerPage = ({ value, onChange }) => (
  <div>
    <span>{i18next.t("pagination.per_page")} : </span><br />
    <input
      type="text"
      defaultValue={value}
      onChange={e => onChange(e.target.value)}
    />
  </div>
);


export default PerPage;